// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3Pw57IGb8Gy4UZGsUlB3Bo","status":"_1tN2TrzkJZY_gOYXHM6Oq-"};